import getAllDescendantTextNodeValues from './getAllDescendantTextNodeValues';

/**
 * Resolves link text on a variety of different links (e.g. image links).
 *
 * @param element Link element containing the text.
 * @returns string Link text.
 */
const getLinkText = (element, win) => {
	// if there is at least one text node, return the value
	// if there is no text node but there is an image, return image alt, title, or src value
	// otherwise if the element has an href attribute, return href value

	let linkText = getAllDescendantTextNodeValues(element, undefined, win);

	if (linkText === '') {
		const $element = $(element);
		const $img = $element.find('img');
		linkText =
			$img.attr('alt') ||
			$img.attr('title') ||
			$img.attr('src') ||
			$element.attr('href') ||
			'';
	}

	return linkText.trim();
};

export default getLinkText;
